import React, { useState, useRef, useEffect } from 'react';
import './Home.css';
import './Buttons.css';
import './Instructions.css'
import AuthForm from './AuthForm';

const LandingPage = ({
    isLocked,
    credentials,
    handleChange,
    handleRegister,
    handleLogin,
    handleResetPassword,
    handleConfirmResetPassword,
    errorMessage,
    handleTryDemo,
    isResetting
}) => {
    const [authMode, setAuthMode] = useState(null);
    const authFormRef = useRef(null);
    const [showDemoVideo, setShowDemoVideo] = useState(false);

    useEffect(() => {
        if (authMode && authFormRef.current) {
            authFormRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [authMode]);

    const quotes = [
        "Last year I forgot I planted kale - GrowYourFoodApp didn't.",
        "I planted with my neighbour for the first time. We're both growing tomatoes now.",
        "Preserved my first batch of cucumbers - three jars and a whole lot of pride.",
        "Sprouted lettuce in April. By June, I was making garden wraps every day."
    ];
    const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentQuoteIndex((prevIndex) => (prevIndex + 1) % quotes.length);
        }, 4000);
        return () => clearInterval(interval);
    }, []);

    return (
        <main className="home-wrapper">
            <section className="home">
                <header className="hero">
                {isLocked && (
                     <div className="lock-banner">
                        <p>GrowYourFoodApp is temporarily unavailable while we perform maintenance. Please check back shortly.</p>
                     </div>
                )}

                    <h3>Grow what you eat. Eat what you grow-season by season</h3>
                    <p>GrowYourFoodApp helps you plant, preserve, and plate with confidence-so your harvest sustains you all year long.</p>
                </header>
               {/* Primary CTA */}
                <div className="cta-pair">
                     <button className="button" onClick={() => setShowDemoVideo(true)}>
                           Watch a Demo
                      </button>
                      <p className="cta-subtext">Explore the app using a sample gardener.</p>
                </div>
<h3 className="testimonial-heading">What Gardeners Are Saying</h3>
                <div className="quote-rotator">
                    <p key={currentQuoteIndex}>{quotes[currentQuoteIndex]}</p>
                </div>

                {/* Removed Why/How sections */}

                {!isResetting && (
                    <section id="start" className="collapsible-section">
                        <div className="section-content">
                            <div className="cta-group">


                                {/* Availability + Create Account */}
                                <div className="cta-pair">
                                    <p className="location-notice">
                                        Currently only available for gardeners on Vancouver Island from Nanaimo to Langford.
                                    </p>

                                    <p className="movement-tagline">
                                        Join the Seed to Feed Movement: Grow, eat, and share what you learn.
                                    </p>

                                    <button className="button" disabled={isLocked} onClick={() => setAuthMode('register')}>
                                        Create a New Account
                                    </button>
                                    <p className="cta-subtext">Join a growing community of home gardeners.</p>
                                </div>

                                {/* Sign In */}
                                <div className="cta-pair">
                                    <button className="button" disabled={isLocked} onClick={() => setAuthMode('login')}>
                                        Sign In
                                    </button>
                                    <p className="cta-subtext">Already growing with us?</p>
                                </div>

                            </div>
                        </div>
                    </section>
                )}

                {showDemoVideo && (
                <div className="video-modal">
                    <div className="video-modal-content">
                        <button className="button" onClick={() => setShowDemoVideo(false)}>
                            Close Demo
                        </button>

                        <video 
                            controls 
                            autoPlay 
                            style={{ 
                                width: '100%', 
                                maxHeight: '70vh',
                                objectFit: 'contain',
                                borderRadius: '8px' 
                            }}
                         >
                            <source src="/videos/WatchDemo.mp4" type="video/mp4" />
                        </video>
                    </div>
                </div>
                )}


                {(authMode || isResetting) && (
                    <div className="auth-form-wrapper" ref={authFormRef}>
                        <AuthForm
                            credentials={credentials}
                            handleChange={handleChange}
                            handleRegister={handleRegister}
                            handleLogin={handleLogin}
                            handleResetPassword={handleResetPassword}
                            handleConfirmResetPassword={handleConfirmResetPassword}
                            errorMessage={errorMessage}
                            isRegistering={authMode === 'register'}
                            isResetting={isResetting}
                        />
                    </div>
                )}
            </section>
        </main>
    );
};

export default LandingPage;
